if (document.querySelector(".js-ratingStars") != null) {
    $(".js-ratingStars").each(function (idx, el) {
        var input = $(this).find('input');
        var spans = $(this).find('span');
        var curRatimg = 0;

        function drawStarts(val) {
            $(spans).each(function (idx, el) {
                if (parseInt(val - 1) >= parseInt(idx)) {
                    $(el).find('use').attr('xlink:href', '#icon-star-filled');
                } else {
                    $(el).find('use').attr('xlink:href', '#icon-star-blank');
                }
            })
        }

        drawStarts(4);

        spans.hover(
            function () {
                drawStarts(parseInt($(this).index() + 1));
            },
            function () {
                drawStarts(curRatimg)
            }
        );

        spans.click(function () {
            curRatimg = $(this).index() + 1;
            drawStarts(parseInt(curRatimg));
            input.val(curRatimg);
        });
    });
}

if (document.querySelector(".js-addPhotos") != null) {
    $('.js-addPhotos').click(function () {
        $('input[type=file]').click();
    });

    $('input[type=file]').change(function () {
        let name = '';
        let files = Array.from($('input[type=file]')[0].files);

        files.forEach(function (val, idx) {
            if (name == '') {
                name = val.name;
            } else {
                name += ', ' + val.name;
            }
        });
        $('.js-addPhotos span').html(name)
    });
}
